import isEqual from 'lodash/isEqual';

/**
 * Given a “default” and a “current” filter object,
 * returns how many top‐level keys have changed.
 */
export function countChangedKeys<T extends Record<string, any>>(
  defaults: T,
  current: Partial<T>,
): number {
  let cnt = 0;
  (Object.keys(defaults) as Array<keyof T>).forEach((key) => {
    const def = defaults[key];
    const cur = current[key];
    if (!isEqual(def, cur)) cnt += 1;
  });
  return cnt;
}
